import React, { useState } from 'react';
import { Input, Label } from 'reactstrap';
import InputMask from 'react-input-mask';

const InputMaskPhone = props => {
  const { label, name } = props;
  const [value, setValue] = useState('');

  const handleMask = v => {
    const digits = !v ? '' : v.replace(/[^\d]/g, '');

    const cut = digits.length <= 10 ? 6 : 7;
    const max = digits.length > 11 ? 11 : digits.length;
    if (max < 3) return `(${digits.substring(0, 2)}`;
    if (max <= 6)
      return `(${digits.substring(0, 2)}) ${digits.substring(2, cut)}`;
    else
      return `(${digits.substring(0, 2)}) ${digits.substring(
        2,
        cut
      )}-${digits.substring(cut, max)}`;
  };

  const handleChange = e => {
    const valueFormated = handleMask(e.target.value);
    props.onChange && props.onChange(valueFormated);
    setValue(valueFormated);
  };

  return (
    <React.Fragment>
      {label && <Label htmlFor={name}>{label}:</Label>}
      <Input
        {...props}
        value={value}
        onChange={handleChange}
        tag={InputMask}
        type='tel'
      />
    </React.Fragment>
  );
};

export default InputMaskPhone;



// WEBPACK FOOTER //
// ./src/componentes/InputMaskPhone/index.js